import { APPLICATION, PRODUCT, GENERIC_ERROR_URL } from "@/constants";
import logError from "@/utils/logger";

const fetchGenericError = async (errorStatusType: string) => {
  let pageJson: {
    title?: string;
    ctaPrimaryBtnLabel?: string;
    ctaSecondaryBtnLabel?: string;
    modalDescription?: string;
  } | null = {};

  try {
    const fetchURL = `${GENERIC_ERROR_URL}/${PRODUCT}-${APPLICATION}/${errorStatusType}`;
    const response = await fetch(fetchURL);
    if (!response.ok) {
      return {};
    }

    const res = await response.json();
    pageJson = {
      title: res.data.titleText,
      ctaPrimaryBtnLabel: res.data.ctaButtonText,
      modalDescription: res.data.descriptionText,
    };
  } catch (e) {
    logError(e as Error, { location: "fetchGenericErrors.tsx" });
    pageJson = null;
  }

  return pageJson;
};

export default fetchGenericError;
